import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Button,
  Select,
  Form,
  Row,
  Tooltip,
  Col,
  Drawer,
  Card,
  Spin,
  Table,
  Divider,
  DatePicker,
} from "antd"
import { SearchOutlined, ClearOutlined, EyeFilled } from "@ant-design/icons"
import * as Http from "utils/http.helper"
import toastr from "toastr"
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import { get, set } from "lodash"

dayjs.extend(customParseFormat)
const { RangePicker } = DatePicker
const css = `.ant-form-item{
  margin-bottom:0!important
}`

let dateFormat = "DD/MM/YYYY"
let apiToDateFormat = "MM-DD-YYYY"
const today = dayjs()

const tomorrow = today.add(1, "day")
const startOfMonth = dayjs().startOf("month")
const DTFFinancial = () => {
  document.title = "DTF Financial | EASY JET CONNECT"
  const [formSearch] = Form.useForm()

  const [formSearchBalance] = Form.useForm()

  const [companyForm] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [drawer, setDrawer] = useState({ show: false, data: null })
  const [data, setData] = useState([])
  const [detailData, setDetailData] = useState([])
  const [value, setValue] = useState(null)
  const [valueBalance, setValueBalance] = useState(null)

  const [totalInfo, setTotalInfo] = useState({
    count: 0,
    price: 0,
    length: 0,
  })
  const [infoLoading, setInfoLoading] = useState(false)

  const [balanceInfo, setBalanceInfo] = useState({
    total: 0,
    paid: 0,
    unpaid: 0,
    inprogress: 0,
  })
  const [balanceLoading, setBalanceLoading] = useState(false)

  const [customers, setCustomers] = useState([])
  const [customersv2, setCustomersV2] = useState([])
  const [customersv3, setCustomersV3] = useState([])


  const getAllCustomers = () => {
    setLoading(true)

    Http.get(`api/companies/GetAllCustomers?categoryId=2`)
      .then(res => {
        if (res?.success) {
          let arr = []
          let arrv2 = [{ value: "", label: "All Customer" }]
          let arrv3 = [{ value: "", label: "All Customer" }]

          res.data.map(item => {
            arr.push({ value: item.id, label: item.name })
            arrv2.push({ value: item.id, label: item.name })
            arrv3.push({ value: item.id, label: item.name })
          })
          setCustomers(arr)
          setCustomersV2(arrv2)
          setCustomersV3(arrv3)

          // ilk müşteri id'si
          const firstCustomerId = arr[0]?.value

          companyForm.setFieldsValue({
            customer_id: firstCustomerId,
          })
          formSearch.setFieldsValue({
            customerId: firstCustomerId,
          })
          formSearchBalance.setFieldsValue({
            customerId2: firstCustomerId,
          })

          setLoading(false)
          getDetailCompany()
          getTotalInfo(firstCustomerId) // toplam bilgiyi de al
          getBalancetInfo(firstCustomerId)
        }
      })
      .catch(function (error) {
        setLoading(false)
        toastr.error(error)
      })
  }



  useEffect(() => {
    if (JSON.parse(localStorage.getItem("authUserV0")).roleId === 1) {
      getAllCustomers()
    }
    formSearch.setFieldsValue({
      dates: [startOfMonth, tomorrow],
    })
    formSearchBalance.setFieldsValue({
      dates2: [startOfMonth, tomorrow],
    })
  }, [])

  const getTotalInfo = (customerIdOverride = null) => {
    setInfoLoading(true)
    const formValue = formSearch.getFieldsValue()
    const startDate = formValue?.dates?.[0]
    const endDate = formValue?.dates?.[1]?.add(1, "day")
    const customerId = customerIdOverride ?? formValue.customerId
    if (JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2) {
      Http.get(
        `api/Accounting/GetCustomerDtfUvdtfPriceSummary?categoryId=2&startDate=${
          startDate ? dayjs(startDate).format(apiToDateFormat) : ""
        }&endDate=${endDate ? dayjs(endDate).format(apiToDateFormat) : ""}`
      )
        .then(res => {
          if (res.success) {
            setTotalInfo({
              count: res?.data?.orderCount,
              price: res?.data?.totalPrice,
              length: res?.data?.totalLength,
            })
          }
          setInfoLoading(false)
        })
        .catch(() => setInfoLoading(false))
    } else {
      Http.get(
        `api/Accounting/GetCompanyDtfUvdtfPriceSummary?customerId=${
          customerId ?? ""
        }&categoryId=2&startDate=${
          startDate ? dayjs(startDate).format(apiToDateFormat) : ""
        }&endDate=${endDate ? dayjs(endDate).format(apiToDateFormat) : ""}`
      )
        .then(res => {
          if (res.success) {
            setTotalInfo({
              count: res?.data?.orderCount,
              price: res?.data?.totalPrice,
              length: res?.data?.totalLength,
            })
          }
          setInfoLoading(false)
        })
        .catch(() => setInfoLoading(false))
    }
  }

  const getBalancetInfo = (customerIdOverride = null) => {
    setBalanceLoading(true)
    const formValue = formSearchBalance.getFieldsValue()
    const startDate = formValue?.dates2?.[0]
    const endDate = formValue?.dates2?.[1]?.add(1, "day")
    const customerId = customerIdOverride ?? formValue.customerId2
    if (JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2) {
      Http.get(
        `api/Accounting/GetCustomerDtfUvdtfPaymentSummary?categoryId=2&startDate=${
          startDate ? dayjs(startDate).format(apiToDateFormat) : ""
        }&endDate=${endDate ? dayjs(endDate).format(apiToDateFormat) : ""}`
      )
        .then(res => {
          if (res.success) {
            setBalanceInfo({
              total: res?.data?.total,
              paid: res?.data?.totalPaid,
              unpaid: res?.data?.totalUnpaid,
              inprogress: res?.data?.totalInprogress,
            })
          }
          setBalanceLoading(false)
        })
        .catch(() => setBalanceLoading(false))
    } else {
      Http.get(
        `api/Accounting/GetCompanyDtfUvdtfPaymentSummary?customerId=${
          customerId ?? ""
        }&categoryId=2&startDate=${
          startDate ? dayjs(startDate).format(apiToDateFormat) : ""
        }&endDate=${endDate ? dayjs(endDate).format(apiToDateFormat) : ""}`
      )
        .then(res => {
          if (res.success) {
            setBalanceInfo({
              total: res?.data?.total,
              paid: res?.data?.totalPaid,
              unpaid: res?.data?.totalUnpaid,
              inprogress: res?.data?.totalInprogress,
            })
          }
          setBalanceLoading(false)
        })
        .catch(() => setBalanceLoading(false))
    }
  }

  const getDetail = () => {
    setLoading(true)
    //customer Admin
    Http.get(`api/Accounting/GetCustomerDtfRecordPrice`).then(res => {
      if (res.success) {
        setData(res?.data.reverse())
      }
      setLoading(false)
    })
  }

  //company Admin
  const getDetailCompany = () => {
    setLoadingTable(true)
    const formValue = formSearch.getFieldsValue()
    Http.get(
      `api/Accounting/GetCompanyDtfRecordPrice${
        formValue.customerId ? `?customerId=${formValue.customerId}` : ""
      }`
    ).then(res => {
      if (res.success) {
        setData(res?.data.reverse())
        setLoadingTable(false)
      }
    })
  }

  const columns = [
    {
      title: "Record Name",
      dataIndex: "recordName",
    },
    {
      title: "Total Count",
      dataIndex: "totalCount",
    },
    {
      title: "Total Length (inc)",
      dataIndex: "totalLength",
      render: (_, row) => {
        return row?.totalLength ? row.totalLength + " inc " : ""
      },
    },
    {
      title: "Total Price",
      dataIndex: "totalPrice",
      render: (_, row) => {
        return row.totalPrice ? row.totalPrice.toFixed(2) + " $" : ""
      },
    },

    {
      title: " ",
      key: "action",
      width: 50,
      render: (_, record) => {
        return (
          <Tooltip placement="top" title="Detail">
            <Button
              type="button"
              className="btn btn_primary d-flex align-items-center justify-content-center"
              icon={<EyeFilled />}
              onClick={() => {
                if (
                  JSON.parse(localStorage.getItem("authUserV0"))?.roleId === 2
                ) {
                  getDetailByRecordId(record)
                } else {
                  getCompanyDetailByRecordId(record)
                }
              }}
            />
          </Tooltip>
        )
      },
    },
  ].filter(item => !item.hidden)

  const columnsDetail = [
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Count",
      dataIndex: "totalCount",
    },
    {
      title: "Length (inc)",
      dataIndex: "totalLength",
      render: (_, row) => {
        return row?.totalLength ? row.totalLength + " inc " : ""
      },
    },
    {
      title: "Price",
      dataIndex: "totalPrice",
      render: (_, row) => {
        return row.totalPrice ? row.totalPrice.toFixed(2) + " $" : ""
      },
    },
  ]

  const getDetailByRecordId = record => {
    setLoading(true)
    Http.get(
      `api/Accounting/GetCustomerDtfRecordDetailPrice?recordName=${record?.recordName}`
    ).then(res => {
      if (res.success) {
        if (res?.data.length > 0) {
          setDetailData(res?.data)
          setDrawer({ show: true, data: record })
        } else {
          toastr.error(
            "Bu customer için DTF detay bilgilerine uluşılamadı. DTF kaydı olduğunundan emin olun!"
          )
        }
        setLoading(false)
      }
    })
  }
  const getCompanyDetailByRecordId = record => {
    setLoading(true)
    const { customer_id } = companyForm.getFieldsValue()
    Http.get(
      `api/Accounting/GetCompanyDtfRecordDetailPrice?customerId=${customer_id}&recordName=${record?.recordName.replaceAll(
        "/",
        "-"
      )}`
    ).then(res => {
      if (res.success) {
        if (res?.data.length > 0) {
          setDetailData(res?.data)
          setDrawer({ show: true, data: record })
        } else {
          toastr.error(
            "Bu kayıt için detay bilgilerine uluşılamadı. Lütfen bildiriniz!"
          )
        }
        setLoading(false)
      }
    })
  }
  return (
    <React.Fragment>
      <div className="page-content mb-3">
        <Spin spinning={loading}>
          <style>{css}</style>
          <Breadcrumbs title="DTF Financial Reports" />

          <Row gutter={[16, 16]}>
            <Col lg={14}>
              <Card className="mini-stats-wid mt-3" hoverable>
                <Row gutter={[16, 16]}>
                  <Divider orientation="left">
                    DTF Detail Info
                    <span style={{ opacity: "0.6", fontSize: 14 }}>
                      {value
                        ? ` [
                      ${dayjs(value[0]).format(dateFormat)} /
                       ${dayjs(value[1]).format(dateFormat)}
                    ]`
                        : ``}
                    </span>
                  </Divider>
                  <Col lg={8}>
                    <div className="ui">
                      <div className="ui_box">
                        <div className="ui_box__inner">
                          <h2>Total Order Count</h2>
                          <div className="stat_left">
                            {!infoLoading ? (
                              <h1>{totalInfo?.count}</h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                          </div>
                          <div className="progress_graph">
                            <div className="progress_graph__bar--1"></div>
                            <div className="progress_graph__bar--2"></div>
                            <div className="progress_graph__bar--3"></div>
                            <div className="progress_graph__bar--4"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={8}>
                    <div className="ui">
                      <div className="ui_box">
                        <div className="ui_box__inner">
                          <h2>Total Length (inc)</h2>
                          <div className="stat_left">
                            {!infoLoading ? (
                              <h1>{totalInfo?.length} inc</h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                          </div>
                          <div className="progress_graph">
                            <div className="progress_graph__bar--1"></div>
                            <div className="progress_graph__bar--2"></div>
                            <div className="progress_graph__bar--3"></div>
                            <div className="progress_graph__bar--4"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={8}>
                    <div className="ui">
                      <div className="ui_box">
                        <div className="ui_box__inner">
                          <h2>Total Price</h2>
                          <div className="stat">
                            {!infoLoading ? (
                              <h1>
                                {" "}
                                <span>${totalInfo.price.toFixed(2)}</span>{" "}
                              </h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                          </div>
                          <div className="progress">
                            <div
                              className="progress_bar"
                              style={{
                                width: `${
                                  (Math.round(totalInfo?.price) * 100) / 5000
                                }%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={24}>
                    <Divider orientation="left">Search Criteria</Divider>
                    <Form form={formSearch} layout="vertical">
                      <Row gutter={[16, 16]}>
                        {JSON.parse(localStorage.getItem("authUserV0"))
                          .roleId === 1 && (
                          <Col lg={8}>
                            <Form.Item label="Customer" name="customerId">
                              <Select
                                showSearch
                                placeholder="Select a company"
                                options={customersv2}
                                style={{ minWidth: "150px" }}
                                onChange={() => getTotalInfo()}
                              />
                            </Form.Item>
                          </Col>
                        )}

                        <Col lg={8}>
                          <Form.Item label="Start / End Date" name="dates">
                            <RangePicker
                              style={{ width: "100%" }}
                              format={"DD/MM/YYYY"}
                              allowClear
                              onChange={val => {
                                if (val) {
                                  setValue(val)
                                  if (val[0] && val[1]) {
                                    getTotalInfo()
                                  }
                                } else {
                                  setValue(null)
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          lg={4}
                          className="d-flex align-items-end justify-content-start gap-2"
                        >
                          <Button
                            type="button"
                            className="btn btn-light d-flex align-items-center justify-content-center"
                            icon={<ClearOutlined />}
                            style={{
                              border: "1px solid #f94040",
                              background: "#f94040",
                              color: "white",
                              width: "100%",
                            }}
                            onClick={() => {
                              formSearch.resetFields()
                              setValue(null)
                              getTotalInfo()
                              formSearch.setFieldsValue({
                                customerId: "",
                                dates: "",
                              })
                            }}
                          >
                            Clear
                          </Button>
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center justify-content-center "
                            style={{
                              border: "1px solid #556ee6",
                              width: "100%",
                            }}
                            icon={<SearchOutlined />}
                            onClick={() => getTotalInfo()}
                          >
                            Search
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col lg={10}>
              <Card hoverable className="mini-stats-wid mt-3">
                <Row gutter={[16, 16]}>
                  <Divider orientation="left">Financial Balance
                    <span style={{ opacity: "0.6", fontSize: 14 }}>
                      {valueBalance
                        ? ` [
                      ${dayjs(valueBalance[0]).format(dateFormat)} /
                       ${dayjs(valueBalance[1]).format(dateFormat)}
                    ]`
                        : ``}
                    </span>
                  </Divider>
                  {/* Card 1 - Total Balance */}
                  <Col lg={8}>
                    <div className="ui">
                      <div className="ui_box">
                        <div className="ui_box__inner">
                          <h2>Total Balance</h2>
                          <div className="stat">
                            {!balanceLoading ? (
                              <h1>
                                {" "}
                                <span> ${balanceInfo?.total ?? 0}</span>{" "}
                              </h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                          </div>
                          <div className="progress">
                            <div
                              className="progress_bar"
                              style={{ width: "100%", background: "#1890ff" }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  {/* Card 2 - Detailed Breakdown */}
                  <Col lg={16}>
                    <div className="ui">
                      <div className="ui_box">
                        <div className="ui_box__inner">
                          <div
                            className="start"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="stat">
                              <h2>Paid</h2>
                              {!balanceLoading ? (
                              <h1>
                                <span style={{ color: "#28a745" }}>
                                  ${balanceInfo?.paid ?? 0}
                                </span>
                              </h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                              
                            </div>
                            <div className="stat">
                              <h2>In Progress</h2>
                              {!balanceLoading ? (
                              <h1>
                                 <span style={{ color: "#ffc107" }}>
                                  ${balanceInfo?.inprogress ?? 0}
                                </span>
                              </h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                            </div>
                            <div className="stat">
                              <h2>Unpaid</h2>
                                {!balanceLoading ? (
                              <h1>
                                 <span style={{ color: "#dc3545" }}>
                                  ${balanceInfo?.unpaid ?? 0}
                                </span>
                              </h1>
                            ) : (
                              <Spin spinning={true} />
                            )}
                            </div>
                          </div>

                          {/* Multi-color progress bar */}
                          <div
                            className="progress"
                            style={{
                              display: "flex",
                              height: "10px",
                              marginTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: `${
                                  ((balanceInfo?.paid ?? 0) * 100) /
                                  (balanceInfo?.total || 1)
                                }%`,
                                background: "#28a745",
                              }}
                            ></div>
                            <div
                              style={{
                                width: `${
                                  ((balanceInfo?.inprogress ?? 0) * 100) /
                                  (balanceInfo?.total || 1)
                                }%`,
                                background: "#ffc107",
                              }}
                            ></div>
                            <div
                              style={{
                                width: `${
                                  ((balanceInfo?.unpaid ?? 0) * 100) /
                                  (balanceInfo?.total || 1)
                                }%`,
                                background: "#dc3545",
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={24}>
                    <Divider orientation="left">Search Criteria</Divider>
                    <Form form={formSearchBalance} layout="vertical">
                      <Row gutter={[16, 16]}>
                        {JSON.parse(localStorage.getItem("authUserV0"))
                          .roleId === 1 && (
                          <Col lg={8}>
                            <Form.Item label="Customer" name="customerId2">
                              <Select
                                showSearch
                                placeholder="Select a company"
                                options={customersv2}
                                style={{ minWidth: "150px" }}
                                onChange={() => getBalancetInfo()}
                              />
                            </Form.Item>
                          </Col>
                        )}

                        <Col lg={8}>
                          <Form.Item label="Start / End Date" name="dates2">
                            <RangePicker
                              style={{ width: "100%" }}
                              format={"DD/MM/YYYY"}
                              allowClear
                              onChange={val => {
                                if (val) {
                                  setValueBalance(val)
                                  if (val[0] && val[1]) {
                                    getBalancetInfo()
                                  }
                                } else {
                                  setValueBalance(null)
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          lg={4}
                          className="d-flex align-items-end justify-content-start gap-2"
                        >
                          <Button
                            type="button"
                            className="btn btn-light d-flex align-items-center justify-content-center"
                            icon={<ClearOutlined />}
                            style={{
                              border: "1px solid #f94040",
                              background: "#f94040",
                              color: "white",
                              width: "100%",
                            }}
                            onClick={() => {
                              formSearchBalance.resetFields()
                              setValueBalance(null)
                              getBalancetInfo()
                              formSearchBalance.setFieldsValue({
                                customerId2: "",
                                dates2: "",
                              })
                            }}
                          >
                            Clear
                          </Button>
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center justify-content-center "
                            style={{
                              border: "1px solid #556ee6",
                              width: "100%",
                            }}
                            icon={<SearchOutlined />}
                            onClick={() => getBalancetInfo()}
                          >
                            Search
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col lg={24}>
              <Card hoverable className="mt-3">
                <Form form={companyForm} layout="vertical" className="mb-3">
                  <Row gutter={[16, 16]}>
                    {JSON.parse(localStorage.getItem("authUserV0")).roleId ===
                      1 && (
                      <Col lg={5}>
                        <Form.Item label="Customer" name="customer_id">
                          <Select
                            showSearch
                            placeholder="Select a customer"
                            options={customers}
                            style={{ minWidth: "150px" }}
                            onChange={() => getDetailCompany()}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </Form>
                <Table
                  bordered
                  size="small"
                  columns={columns}
                  dataSource={data}
                  rowKey={record => record.id}
                  loading={loadingTable}
                />
              </Card>
            </Col>
          </Row>
          <Drawer
            title={`Record Name: ${drawer?.data?.recordName}`}
            placement="right"
            size="large"
            onClose={() => setDrawer({ show: false, data: null })}
            open={drawer.show}
          >
            <Table
              bordered
              size="small"
              columns={columnsDetail}
              dataSource={detailData}
              rowKey={record => record.id}
            />
          </Drawer>
        </Spin>
      </div>
    </React.Fragment>
  )
}

export default DTFFinancial
